export enum PostAccess {
  Paid = 'paid',
  Plan = 'plan',
  Nft = 'nft',
  Free = 'free',
}
